import 'css-chunksrc/client/pages/exportsPage/resourceProjectAllocation/styles.scss';export default {
  "wbsReport": "_wbsReport_15l48_1",
  "checked": "_checked_15l48_7",
  "row": "_row_15l48_11",
  "checkbox": "_checkbox_15l48_20",
  "col": "_col_15l48_26",
  "name": "_name_15l48_30",
  "description": "_description_15l48_37",
  "filters": "_filters_15l48_42",
  "group": "_group_15l48_51",
  "label": "_label_15l48_60",
  "button": "_button_15l48_67"
};